import React, { useEffect, useState } from "react";
import "./Designers.scss";
import { useBackButton } from "../../hooks/useBackButton";
import Header from "../../components/Header";
import SubHeader from "../../components/SubHeader";
import { useNavigate } from "react-router-dom";
import DesignerCardInfoFull from "../../components/DesignerCardInfoFull";
import { useLocalDB } from "../../contexts/LocalDBContext";

const Designers = () => {
  const navigate = useNavigate();
  const { getAllStudios } = useLocalDB();
  useBackButton("/", false, false);

  const [studios, setStudios] = useState([]);

  useEffect(() => {
    const load = async () => {
      const data = await getAllStudios();
      setStudios(data);
    };

    load();
  }, []);

  return (
    <>
      <Header></Header>
      <SubHeader></SubHeader>
      <div className="row main-page">
        <div className="col col-0 cancel col-md-3">
          <div className="return-btn" onClick={() => {navigate("/")}}>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 20C0 16.2828 0 14.4241 0.307436 12.8786C1.56994 6.53151 6.53151 1.56994 12.8786 0.307436C14.4241 0 16.2828 0 20 0C23.7172 0 25.5759 0 27.1214 0.307436C33.4685 1.56994 38.4301 6.53151 39.6926 12.8786C40 14.4241 40 16.2828 40 20C40 23.7172 40 25.5759 39.6926 27.1214C38.4301 33.4685 33.4685 38.4301 27.1214 39.6926C25.5759 40 23.7172 40 20 40C16.2828 40 14.4241 40 12.8786 39.6926C6.53151 38.4301 1.56994 33.4685 0.307436 27.1214C0 25.5759 0 23.7172 0 20Z"
                fill="white" />
              <path fillRule="evenodd" clipRule="evenodd"
                d="M23.0893 14.4108C22.7638 14.0854 22.2362 14.0854 21.9108 14.4108L16.9108 19.4108C16.7545 19.5671 16.6667 19.7791 16.6667 20.0001C16.6667 20.2211 16.7545 20.4331 16.9108 20.5893L21.9108 25.5893C22.2362 25.9148 22.7638 25.9148 23.0893 25.5893C23.4147 25.2639 23.4147 24.7363 23.0893 24.4108L18.6785 20.0001L23.0893 15.5893C23.4147 15.2639 23.4147 14.7363 23.0893 14.4108Z"
                fill="#191A21" />
            </svg>
            Назад
          </div>
        </div>
        <div className="col col-12 col-md-9">
          {studios.map((studio) => (
            <DesignerCardInfoFull key={studio.id} id={studio.id} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Designers;
